/**
 * Created by anatoly on 10.08.2026
 */

Placements.ENTRIES["boosterUnlockedWindow"] = {
    type: Placements.FREE_FOCUS_MAIN,

    action: function () {
        const shown = cleverapps.dataLoader.load(DataLoader.TYPES.BOOSTER_UNLOCK_WINDOWS) || [];
        const level = cleverapps.user.getHumanReadableNumber();

        const booster = cleverapps.boosters.listBoosters()
            .find((booster) => booster.available.actualLevel === level && !shown.includes(booster.id));

        if (!booster) {
            return;
        }

        cleverapps.focusManager.display({
            focus: "BoosterUnlockedWindow",
            action: function (f) {
                shown.push(booster.id);

                cleverapps.dataLoader.save(DataLoader.TYPES.BOOSTER_UNLOCK_WINDOWS, shown);

                new BoosterUnlockedWindow(booster);
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    }
};
